import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { FormNames } from "../../../../resources/constants";
import { IChangePassState, ICodeResp, IPasswordsPayload } from "./types";

import { fetchSendPhone, fetchSendCode, fetchSendNewPassword } from "./asyncActions";

const initialState: IChangePassState = {
  token: "",
  phone: "",
  email: "",
  name: "",
  code: "",
  password: "",
  passwordRepeat: "",
  showForm: "",
  isLoading: false,
  errorMessage: "",
};

const changePassSlice = createSlice({
  name: "changePass",
  initialState,
  reducers: {
    addPhone(state, action: PayloadAction<string>) {
      state.phone = action.payload;
      state.errorMessage = "";
    },
    clearErrorMessage(state) {
      state.errorMessage = "";
    },
    addCode(state, action: PayloadAction<string>) {
      state.code = action.payload;
    },
    addEmail(state, action: PayloadAction<string>) {
      state.email = action.payload
    },
    addName(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    addPassword(state, action: PayloadAction<IPasswordsPayload>) {
      state.password = action.payload.password;
      state.passwordRepeat = action.payload.passwordRepeat;
    },
    setShowForm(state, action: PayloadAction<string>) {
      state.showForm = action.payload;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSendPhone.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(fetchSendPhone.fulfilled, (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      if (state.showForm === "" || state.showForm === FormNames.PHONE) {
        state.showForm = action.payload;
      }
      state.errorMessage = "";
    });
    builder.addCase(fetchSendPhone.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload || "Ошибка отправки запроса";
    });
    builder.addCase(fetchSendCode.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(
      fetchSendCode.fulfilled,
      (state, action: PayloadAction<ICodeResp>) => {
        state.isLoading = false;
        state.showForm = action.payload.form;
        state.token = action.payload.token;
      }
    );
    builder.addCase(fetchSendCode.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload || "Ошибка подтверждения кода";
    });
    builder.addCase(fetchSendNewPassword.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      fetchSendNewPassword.fulfilled,
      (state, action: PayloadAction<string>) => {
        state.isLoading = false;
        state.showForm = action.payload;
      }
    );
    builder.addCase(fetchSendNewPassword.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload || "Ошибка установки нового пароля";
    });
  },
});

export const { addPhone, addCode, addPassword, addEmail, addName, setShowForm, reset, clearErrorMessage } =
  changePassSlice.actions;

export default changePassSlice.reducer;
